// @readonly
// @enum

export const RollAccessLevel = Object.freeze({
  DASHBOARD_ROUTE: ["ADMIN_USER"],
  MANAGEMENT_ROUTE: ["MANAGMENT_USER", "ADMIN_USER"],
  ACCOUNTANT_ROUTE: ["ACCOUNTANT_USER", "ADMIN_USER"],
  CRM_ROUTE: ["CRM_USER", "ADMIN_USER"],
  CONTENT_ROUTE: ["CONTENT_USER", "ADMIN_USER"],
  SUPPLIER: ["SUPPLIER", "ADMIN_USER"],
});

export const RouteMode = Object.freeze({
  DASHBOARD_ROUTE: "DASHBOARD_ROUTE",
  MANAGEMENT_ROUTE: "MANAGEMENT_ROUTE",
  ACCOUNTANT_ROUTE: "ACCOUNTANT_ROUTE",
  CRM_ROUTE: "CRM_ROUTE",
  CONTENT_ROUTE: "CONTENT_ROUTE",
  SUPPLIER: "SUPPLIER",
});
